import React from "react";
import { UploadSimple } from "@phosphor-icons/react";
import { ExtendedSidebar } from "./ExtendedSidebar";
import { SearchAction } from "./SearchAction";
import { PlusMenu } from "./PlusMenu";

export const DataActions: React.FC = () => {
  return (
    <>
      <PlusMenu allowedTypes={["object", "vectorMemory"]} />
      <ExtendedSidebar.ActionButton icon={UploadSimple} />
      <SearchAction />
    </>
  );
};
